import React, { useEffect } from 'react';
import { loadBrevoWidget } from '../../utils/brevo';

/**
 * Mounts the Brevo Conversations widget. Single workspace, one chatbot —
 * the bot branches on the visitor's `user_role` attribute (set per-audience
 * by userContext, auth providers, and public flow pages).
 *
 * Mount once per page tree.
 */
const BrevoChatWidget = () => {
    useEffect(() => {
        void loadBrevoWidget();
    }, []);

    return null;
};

export default BrevoChatWidget;
